import { Field, useField } from 'formik';
import * as Yup from 'yup';
import { Typography, IconButton, Dialog, DialogTitle, DialogContent, Button } from '@mui/material';
import { useState, useCallback } from 'react';
import { HelpOutline, Close } from '@mui/icons-material';
import styled from 'styled-components';

import { FormRowsDivider, InputField } from '../../../fields';
import { SendTestLead } from '../../send-test-lead';

export const RoistatIntegration = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [{ value: roistatIntegration }, { error }] = useField('campaign.roistatIntegration');
  const [{ value: campaignId }] = useField('campaign.id');

  const validate = (value: string, schema: Yup.AnySchema) => {
    try {
      schema.validateSync(value);
    } catch (error) {
      return (error as any).message;
    }
  };

  const handleModalClose = useCallback(() => {
    setModalVisible(false);
  }, []);

  return (
    <>
      <FormRowsDivider sx={{ marginTop: '20px' }} />

      <Typography sx={{ fontWeight: 'bold', marginBottom: '12px' }}>Roistat</Typography>

      <Field
        name="campaign.roistatIntegration.webhookUrl"
        component={InputField}
        label="Roistat webhook url"
        placeholder="https://cloud.roistat.com/integration/webhook?key=123qwe"
        className="form-field webhook-input"
        validate={(value: string) => validate(value, Yup.string().url().nullable())}
      />

      <IconButton
        onClick={(event) => {
          event.preventDefault();
          setModalVisible(true);
        }}
      >
        <HelpOutline />
      </IconButton>

      <br />
      <br />

      {roistatIntegration?.webhookUrl && !error && (
        <SendTestLead
          integrationId="roistat"
          campaignId={campaignId}
          params={{ webhookUrl: roistatIntegration.webhookUrl }}
        />
      )}

      <Dialog
        open={modalVisible}
        onClose={() => {
          setModalVisible(false);
        }}
        maxWidth="lg"
      >
        <DialogTitle>
          <CloseModalButton onClick={handleModalClose}>
            <Close />
          </CloseModalButton>
        </DialogTitle>

        <DialogContent>
          Вам нужно создать интеграцию через Webhook
          <br />
          <Button
            href="https://blog.embedgames.app/articles/integraciya-s-roistat"
            target="_blank"
            sx={{ marginLeft: '-8px' }}
          >
            Подробнее
          </Button>
          <br />
          <br />
          <ScreenshotImage src="https://cdn2.embedgames.app/images/roistat.png" />
        </DialogContent>
      </Dialog>
    </>
  );
};

const CloseModalButton = styled(IconButton)`
  position: absolute;
  top: 8px;
  right: 8px;
`;

const ScreenshotImage = styled.img`
  width: 940px;
  min-height: 680px;
`;
